import { toggleFavoriteGame } from "@/services";
import {
  addFavorite,
  addRecent,
  cacheGame,
  clearFavorites,
  clearRecent,
  dispatch,
  removeFavorite,
  setFavorites,
  useSelector,
} from "@/store";
import { Game } from "@/types";

import { useIsLoggedIn } from "./useIsLoggedIn";

export const useGameState = () => {
  const { favorites, recent, gameCache } = useSelector((state) => state.game);
  const isLoggedIn = useIsLoggedIn();

  const cache = gameCache || {};
  const favoriteGames = favorites.map((id) => cache[id]).filter(Boolean) as Game[];
  const recentGames = recent.map((id) => cache[id]).filter(Boolean) as Game[];

  return {
    favorites,
    recent,
    favoriteGames,
    recentGames,
    isFavorite: (id: string) => favorites.includes(id),
    setFavorites: (ids: string[]) => dispatch(setFavorites(ids)),
    addFavorite: (id: string) => dispatch(addFavorite(id)),
    removeFavorite: (id: string) => dispatch(removeFavorite(id)),
    toggleFavoriteWithPersist: (id: string, game?: Game) => {
      if (!id) return;
      if (game) dispatch(cacheGame(game));
      const isFav = favorites.includes(id);
      dispatch(isFav ? removeFavorite(id) : addFavorite(id));
      if (isLoggedIn) {
        toggleFavoriteGame(id).catch(() => {
          dispatch(isFav ? addFavorite(id) : removeFavorite(id));
        });
      }
    },
    addRecent: (id: string) => dispatch(addRecent(id)),
    cacheGame: (game: Game) => dispatch(cacheGame(game)),
    clearRecent: () => dispatch(clearRecent()),
    clearFavorites: () => dispatch(clearFavorites()),
  };
};
